module.exports = __webpack_public_path__ + "static/media/DashboardIconBlack.a1681017.svg";